<template>
  <BlockModal :open="showAllSpeakers" :speakers="state.speakers" @close="openAllSpeakers">

  </BlockModal>
  <div v-if="state.speakers && state.speakers.length > 0" class="relative my-20">
    <div class="absolute w-full h-full bg-[#2699C6] z-[-1] opacity-40" style="filter: blur(514.1500244140625px);"></div>

    <div class="lg:mb-[70px] md:mb-10 mb-[20px] lg:text-left text-center">
      <p class="lg:text-[32px] md:text-[24px] text-[16px] font-[500] text-[#2699c6] lg:mb-[9px]" style="line-height: normal">SPEAKEŘI</p>
      <p class="font-extrabold lg:text-[56px] md:text-[40px] text-[28px] font-gray-900 mb-[20px] lg:mb-[70px]" style="line-height: normal">Na koho se můžete
        těšit?</p>

      <div class="hidden md:grid md:grid-cols-4 lg:grid-cols-4 gap-6 mt-6">
        <SpeakerCard
          v-for="(speaker, j) in state.speakers.slice(0,8)"
          :key="j"
          :speaker="speaker"
        />
      </div>
      <div class="md:hidden">
        <carousel
          :speakers="state.speakers"></carousel>
      </div>
    </div>

    <div class="flex justify-center">
      <div @click="openAllSpeakers" class="cursor-pointer rounded-full bg-[#2699C6] px-[49px] py-4 text-[20px] text-white font-[600]"
         >Všichni speakeři</div>
    </div>
  </div>
</template>

<script setup>
import SpeakerCard from "./SpeakerCard.vue";

import {useSpaeakersStore} from "../../stores/speakers";
import Carousel from "./Carousel.vue";
import BlockModal from "./BlockModal.vue";
import {ref} from "vue";

const state = useSpaeakersStore();
const showAllSpeakers = ref(false);
function openAllSpeakers() {
  showAllSpeakers.value = !showAllSpeakers.value;
}
</script>
